module.exports = __webpack_public_path__ + "static/img/space.88eb845.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/space.png
// module id = VTdc
// module chunks = 1